import type { MouseEvent } from 'react';

import { ExternalLink } from '@uikit/components/ExternalLink';
import { AngleRight } from '@uikit/icons/AngleRight';

import { useAuth } from '@shared/common/providers/AuthProvider';
import useCheckRequiredSelfData from '@shared/hooks/useCheckRequiredSelfData';

import { useTurtleClubMembership } from '@query/turtle-club';

import { cn } from '@ui/uikit/utils';

export const StartEarningWithTurtleClubActionButton = () => {
  const { check } = useCheckRequiredSelfData();

  const { isAuth } = useAuth();

  const { data: turtleClubMembership } = useTurtleClubMembership({ isAuth });

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    if (!check({ auth: true })) {
      event.preventDefault();

      return;
    }
  };

  return (
    <ExternalLink
      onClick={handleClick}
      href="https://app.turtle.club/?ref=MAGICSQR"
      className={cn(
        'button button-solid-secondary button-md md:button-xl md:min-h-12 rounded-xl gap-2',
        { ['button-disabled']: !turtleClubMembership?.joined },
      )}
    >
      Visit Turtle Club and Get Started <AngleRight className="icon-lg" />
    </ExternalLink>
  );
};
